export default "__VITE_ASSET__DdjwAqEk__"